const STORAGE_KEY_PREFIX = "fpsl_preference_";
const CHANGE_EVENT = "fpsl-preference-change";

const notify = () => window.dispatchEvent(new Event(CHANGE_EVENT));

export function getFpslPreference(accountId: string): boolean | null {
  const value = window.localStorage?.getItem(STORAGE_KEY_PREFIX + accountId);
  if (value === null) {
    return null;
  }
  return value === "true";
}

export function setFpslPreference(accountId: string, optIn: boolean) {
  window.localStorage?.setItem(STORAGE_KEY_PREFIX + accountId, String(optIn));
  notify();
}

export function clearFpslPreference(accountId: string) {
  window.localStorage?.removeItem(STORAGE_KEY_PREFIX + accountId);
  notify();
}

export const FPSL_PREFERENCE_CHANGE_EVENT = CHANGE_EVENT;
